import React from 'react';
import { useTranslation } from 'react-i18next';
import CheckIcon from '@wix/da-ds/pkg/Icons/Check';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import noop from '@wix/da-shared-react/pkg/utils/noop';
import UnlockWithCoreUpsellModal from '../UnlockWithCoreUpsellModal/UnlockWithCoreUpsellModal';

import s from './CoreMonetizationUpsellPopup.scss';

export interface Props {
  requestClose?: () => void;
}

const CoreMonetizationUpsellPopup: React.FC<Props> = ({ requestClose = noop }) => {
  const { t } = useTranslation();

  const body = (
    <ul>
      <li>
        <CheckIcon className={s['benefit-icon']} size={IconSize.TINY} disableDefaultColors />
        {t('deviationSubmit.modals.coreMonetizationUpsell.benefits.1')}
      </li>
      <li>
        <CheckIcon className={s['benefit-icon']} size={IconSize.TINY} disableDefaultColors />
        {t('deviationSubmit.modals.coreMonetizationUpsell.benefits.2')}
      </li>
      <li>
        <CheckIcon className={s['benefit-icon']} size={IconSize.TINY} disableDefaultColors />
        {t('deviationSubmit.modals.coreMonetizationUpsell.benefits.3')}
      </li>
    </ul>
  );

  return (
    <UnlockWithCoreUpsellModal
      title={t('deviationSubmit.modals.coreMonetizationUpsell.title')}
      body={body}
      cta={t('deviationSubmit.modals.coreMonetizationUpsell.cta')}
      referralType={ReferralType.SUBMIT_SELL_SECTION}
      className={s['root']}
      requestClose={requestClose}
    />
  );
};
CoreMonetizationUpsellPopup.displayName = 'CoreMonetizationUpsellPopup';

export default CoreMonetizationUpsellPopup;
